import { __awaiter, __generator, __read } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { fetchIdentity } from '@office-start/identity-service';
/**
 * Generates a query function for react query
 * that can be used inside or outside the hook version
 * of the fetch state call
 * @param getStateFunction Function that does the actual fetching
 * of new user state
 */
export var getNewUserQueryFn = function (getStateFunction) {
    return function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, componentContext, identity, featureGates;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        fetchOfficeComponentContext(),
                        fetchIdentity(),
                        fetchFeatureGates(),
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 3]), componentContext = _a[0], identity = _a[1], featureGates = _a[2].result;
                    return [2 /*return*/, getStateFunction(identity, componentContext, featureGates)];
            }
        });
    }); };
};
//# sourceMappingURL=getNewUserQueryFn.js.map